import { clsx } from "clsx"
import { ReactNode } from "react"
import { Button } from "."
import "./ButtonTabStyle.sass"

interface ButtonTabProps {
  items: {
    icon?: ReactNode
    title: ReactNode
    onClick?: () => void
    to?: string
    hide?: boolean
    active?: boolean
  }[]
  className?: string
}
export const ButtonTab = ({ items, className }: ButtonTabProps) => {
  return (
    <div className={clsx("button-tab-wrapper", className)}>
      {items
        .filter((item) => !item.hide)
        .map(({ icon, title, onClick, to, active }, id) => (
          <Button
            key={id}
            color="primary"
            activeClassName="active"
            onClick={onClick}
            to={to}
            className={clsx({
              active,
            })}
          >
            {icon}
            {title}
          </Button>
        ))}
    </div>
  )
}
